import { useQuery } from "convex/react";
import { Link } from "react-router";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { api } from "../../../../convex/_generated/api";
import { Clio } from "./clio";

export default function ClioPage() {
	const accountsQuery = useQuery(api.clio.queries.listAccounts);
	const isLoading = accountsQuery === undefined;
	const accounts = accountsQuery ?? [];

	if (isLoading) {
		return (
			<div className="flex h-full items-center justify-center p-8 text-sm text-muted-foreground">
				Loading Clio…
			</div>
		);
	}

	if (accounts.length === 0) {
		return (
			<div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
				<div>
					<h1 className="text-xl font-semibold">No Clio accounts connected</h1>
					<p className="text-sm text-muted-foreground">
						Connect a Clio Manage account to explore matters, notes, and
						documents.
					</p>
				</div>
				<Link
					to="/workspace/connections"
					className={cn(buttonVariants({ variant: "default" }))}
				>
					Connect Clio
				</Link>
			</div>
		);
	}

	return (
		<div className="flex h-full flex-col">
			<Clio accounts={accounts} defaultLayout={[22, 30, 48]} />
		</div>
	);
}
